var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 960a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64V96a64 64 0 0 1 64-64h896a64 64 0 0 1 64 64v864z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 0h320v32H128zM576 0h320v32H576z",
    fill: "#434854"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112 144m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#434854"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272 144m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#434854"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M432 144m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#434854"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M592 144m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#434854"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M960 288a32 32 0 0 1-32 32H96a32 32 0 1 1 0-64h832a32 32 0 0 1 32 32z",
    fill: "#434854"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M928 319.968H96a31.584 31.584 0 0 1-27.104-16 30.88 30.88 0 0 0-4.896 16 32 32 0 0 0 32 32h832a32 32 0 0 0 32-32 30.88 30.88 0 0 0-4.896-16 31.584 31.584 0 0 1-27.104 16z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M960 928a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V416a32 32 0 0 1 32-32h832a32 32 0 0 1 32 32v512z",
    fill: "#469FCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M859.328 552.576l-67.872-67.872a16 16 0 0 0-22.624 22.624l67.872 67.872a16 16 0 0 0 22.624-22.624zM724.384 506.496a16 16 0 0 0-22.624 22.624l113.12 113.12a16 16 0 0 0 22.624-22.624l-113.12-113.12z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M912 144m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#3AAD73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112 191.968a47.872 47.872 0 0 1-45.056-32 47.456 47.456 0 0 0-2.944 16 48 48 0 0 0 96 0c0-5.632-1.152-10.976-2.944-16-6.624 18.592-24.192 32-45.056 32zM272 191.968a47.872 47.872 0 0 1-45.056-32 47.456 47.456 0 0 0-2.944 16 48 48 0 0 0 96 0c0-5.632-1.152-10.976-2.944-16-6.624 18.592-24.192 32-45.056 32zM432 191.968a47.872 47.872 0 0 1-45.056-32 47.456 47.456 0 0 0-2.944 16 48 48 0 0 0 96 0c0-5.632-1.152-10.976-2.944-16-6.624 18.592-24.192 32-45.056 32zM592 191.968a47.872 47.872 0 0 1-45.056-32 47.456 47.456 0 0 0-2.944 16 48 48 0 0 0 96 0c0-5.632-1.152-10.976-2.944-16-6.624 18.592-24.192 32-45.056 32zM957.056 159.968c-6.624 18.592-24.192 32-45.056 32s-38.432-13.408-45.056-32a47.456 47.456 0 0 0-2.944 16 48 48 0 0 0 96 0c0-5.632-1.152-10.976-2.944-16z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForno);
export default __webpack_public_path__ + "static/media/forno.688cb0a96593d011df0884c63ba5726f.svg";
export { ForwardRef as ReactComponent };